import axios from 'axios'
import { VENDA_SEGURO_HABILITADA} from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function vendaSeguroHabilitada (idEmpresa) {
  const url = `${URL}/reserva/empresa/${idEmpresa}/venda-seguro-habilitada`;

  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: VENDA_SEGURO_HABILITADA,
        payload: response

      })
  );
}
